import { createFileRoute } from '@tanstack/react-router';

// The base Interpretation route: the chat box is empty, no chat selected.
// The parent route renders the viewer; this leaf only completes the match.
export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$interpretationId/'
)({});
